export const PRODUCT_COPY = Object.freeze({
  addToCart: "Sepete Ekle",
  soldOut: "Tükendi",
  selectOptions: "Seçenekleri belirle",
  stockUrgency: "Tükenmek Üzere",
  viewAllReviews: "Tüm yorumları görüntüle",
  bundleHeading: "FIRSAT PAKETLERİ",
  singleChoice: "Tekli Seçim",
  bundlePerUnit: " / birim",
  bundleSelectProduct: "Ürün seç",
  inspect: "İncele",
} as const)
